/**
 * dd-drawer-extras
 * OneLive — Duran Duran US (Horizon)
 *
 * Adds a search field above the nav links and Log in / Create account below
 * them inside Horizon's mobile drawer, matching duranduranofficialstore.com.
 *
 * WHY NOT EDIT snippets/header-drawer.liquid DIRECTLY:
 * That is the correct place for this, but the file is 59KB and
 * themeFilesUpsert only accepts whole files — so a four-line addition means
 * retyping 59KB, where a single typo silently breaks mobile navigation.
 *
 * WHY THIS IS SAFE RATHER THAN A HACK:
 * The markup is rendered by Liquid into a <template> in
 * sections/dd-utility-bar.liquid. This script only MOVES those nodes into the
 * drawer — it does not build HTML in JS. And the drawer's <details> carries
 * data-skip-node-update="true", so Horizon's morph explicitly leaves that
 * subtree alone; relocated nodes survive section re-renders.
 *
 * TRADEOFF, STATED PLAINLY: without JS the search and account links stay in
 * the template and never appear. The nav links themselves are unaffected, so
 * the drawer still navigates. If that matters, the fix is the native-file
 * edit above.
 */

const TEMPLATE_ID = 'dd-drawer-extras-template';
const DRAWER_SELECTOR = '.menu-drawer';
const NAV_SELECTOR = '.menu-drawer__navigation';
const UTILITY_SELECTOR = '.menu-drawer__utility-links';
const DONE_FLAG = 'ddDrawerExtras';

function injectExtras(drawer) {
  // Idempotent: the observer can fire more than once for the same drawer.
  if (!drawer || drawer.dataset[DONE_FLAG] === 'true') return;

  const template = document.getElementById(TEMPLATE_ID);
  if (!(template instanceof HTMLTemplateElement)) return;

  const nav = drawer.querySelector(NAV_SELECTOR);
  if (!nav) return;

  const fragment = template.content.cloneNode(true);
  const search = fragment.querySelector('[data-dd-drawer-search]');
  const account = fragment.querySelector('[data-dd-drawer-account]');

  // Search sits above the nav list, below the close button.
  if (search) nav.parentNode.insertBefore(search, nav);

  /*
   * Account links go into Horizon's existing utility-links container, which
   * already sits after the nav and before the featured-products strip in DOM
   * order. Reusing it rather than inserting a sibling keeps the drawer's
   * flex layout and animation indices intact. It may not exist — it only
   * renders when a country or language selector is enabled — so fall back to
   * inserting directly after the nav.
   */
  if (account) {
    const utility = drawer.querySelector(UTILITY_SELECTOR);

    if (utility) {
      utility.insertBefore(account, utility.firstChild);
    } else if (nav.nextSibling) {
      nav.parentNode.insertBefore(account, nav.nextSibling);
    } else {
      nav.parentNode.appendChild(account);
    }
  }

  drawer.dataset[DONE_FLAG] = 'true';
}

function run() {
  const drawer = document.querySelector(DRAWER_SELECTOR);
  if (drawer) injectExtras(drawer);
}

run();

/*
 * The drawer is hydrated lazily (fetchpriority="low" on header-drawer.js), and
 * in the theme editor the whole header group is replaced on every settings
 * change. Watch for a drawer appearing rather than assuming one exists at
 * first run. Disconnects once found outside design mode; stays live in the
 * editor, where re-renders keep happening.
 */
if (!document.querySelector(DRAWER_SELECTOR) || document.documentElement.classList.contains('shopify-design-mode')) {
  const observer = new MutationObserver(() => {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    injectExtras(drawer);

    if (!document.documentElement.classList.contains('shopify-design-mode')) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
